import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Gtp } from 'src/app/shared/gtp';
import { MapToolsService } from '../../../services/map-tools.service';

@Component({
  selector: 'app-tools-iramovil',
  templateUrl: './tools-iramovil.component.html',
  styleUrls: ['./tools-iramovil.component.scss']
})
export class ToolsIraMovilComponent implements OnInit {

  listaMoviles = [];
  listaMovilesFiltered = [];
  mostrarTodos: boolean = false;
  event: Event;

  @Input() moviles: any;
  @Output() eventClose = new EventEmitter<any>();
  @Output() irAMovil = new EventEmitter<any>();

  constructor(
    private gtp: Gtp,
    private MapToolsService: MapToolsService
  ) {
    
  }

  ngOnInit() {
    this.listaMoviles = this.moviles.sort(this.gtp.orderMoviles);
    this.listaMovilesFiltered = this.listaMoviles;
  }

  closeTab(event?: Event):void {
    this.eventClose.emit(event);
  }

  upIrAMovil(latitud, longitud):void {
    let tmp = {
      latitud: latitud, 
      longitud: longitud, 
      zoom: 19,
    }
    this.irAMovil.emit(tmp);
  }

  filterMoviles(query) {
    let res = this.listaMoviles.filter(s => (
      s.des_equipo_rastreo.toLocaleLowerCase().includes(query.toLocaleLowerCase()) ||
      s.cod_equipo_rastreo.toString().includes(query.toLocaleLowerCase())
    ));
    this.listaMovilesFiltered = (query == '') ? this.listaMoviles.sort(this.gtp.orderMoviles) : res.sort(this.gtp.orderMoviles);
  }

  showHideMoviles(state) {
    let newlist = [];
    let display = {
      marker: state,
      cod_equipo_rastreo: false
    }
    this.listaMovilesFiltered.forEach(el => {
      el.checked = state;
      newlist.push(el);
    });
    this.mostrarTodos = (state) ? false : true;
    this.listaMovilesFiltered = newlist.sort(this.gtp.orderMoviles);
    this.MapToolsService.setDisplayMarker(display);
  }

  showHideMovil(state, cod_equipo_rastreo) {
    let newlist = [];
    let display = {
      marker: state,
      cod_equipo_rastreo: cod_equipo_rastreo
    }
    this.listaMovilesFiltered.forEach( (el,i) => {
      if (el.cod_equipo_rastreo == cod_equipo_rastreo) {
        el.checked = state;        
      }
      newlist.push(el);
    });
    this.listaMovilesFiltered = newlist.sort(this.gtp.orderMoviles);
    this.MapToolsService.setDisplayMarker(display);
  }

}
